var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "row" },
    [
      _vm._l(_vm.internalPosts, function(post) {
        return _vm.internalPosts.length
          ? _c(
              "div",
              { staticClass: "col col-12 col-md-6 col-lg-6 col-xl-4 item" },
              [
                _c("div", { staticClass: "item-inner" }, [
                  post.category
                    ? _c("div", {
                        staticClass: "category",
                        class: "cat-label cat-label-" + post.category.slug,
                        style: [
                          post.category.acf.category_color
                            ? {
                                "background-color":
                                  post.category.acf.category_color
                              }
                            : {}
                        ],
                        domProps: { innerHTML: _vm._s(post.category.name) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  post.hasOwnProperty("rating") && post.rating > 0
                    ? _c("div", {
                        staticClass: "rating",
                        class: "rating-label",
                        domProps: { innerHTML: _vm._s(post.rating + "/5") }
                      })
                    : _c("div", {
                        staticClass: "rating",
                        class: "rating-label",
                        domProps: { innerHTML: _vm._s("k.B.") }
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-image-container" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: _vm.wpApi.stripBaseUrl(post["link"]) } },
                        [
                          post["acf"]["config_disable_header"] !== true &&
                          post["acf"]["teaser_video_youtube_id"]
                            ? _c("img", {
                                staticClass: "video-icon",
                                attrs: {
                                  alt: "Video",
                                  src: "/img/ic_video.svg"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          post["acf"]["teaser_image_960_720"] ||
                          post["acf"]["teaser_image_600_290"]
                            ? _c("img", {
                                staticClass: "item-image item-image-290 w-100",
                                attrs: {
                                  alt: post["acf"]["teaser_image_alt_text"],
                                  src: _vm.wpApi.stripHost(
                                    post["acf"]["teaser_image_600_290"]
                                      ? post["acf"]["teaser_image_600_290"]
                                      : post["acf"]["teaser_image_960_720"]
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          post["acf"]["teaser_image_960_720"] ||
                          post["acf"]["teaser_image_440_218"]
                            ? _c("img", {
                                staticClass: "item-image item-image-218 w-100",
                                attrs: {
                                  alt: post["acf"]["teaser_image_alt_text"],
                                  src: _vm.wpApi.stripHost(
                                    post["acf"]["teaser_image_440_218"]
                                      ? post["acf"]["teaser_image_440_218"]
                                      : post["acf"]["teaser_image_960_720"]
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          post["acf"]["teaser_image_960_720"] ||
                          post["acf"]["teaser_image_386_181"]
                            ? _c("img", {
                                staticClass: "item-image item-image-181 w-100",
                                attrs: {
                                  alt: post["acf"]["teaser_image_alt_text"],
                                  src: _vm.wpApi.stripHost(
                                    post["acf"]["teaser_image_386_181"]
                                      ? post["acf"]["teaser_image_386_181"]
                                      : post["acf"]["teaser_image_960_720"]
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          post["acf"]["teaser_image_960_720"] ||
                          post["acf"]["teaser_image_435_145"]
                            ? _c("img", {
                                staticClass: "item-image item-image-145 w-100",
                                attrs: {
                                  alt: post["acf"]["teaser_image_alt_text"],
                                  src: _vm.wpApi.stripHost(
                                    post["acf"]["teaser_image_435_145"]
                                      ? post["acf"]["teaser_image_435_145"]
                                      : post["acf"]["teaser_image_960_720"]
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          post["acf"]["teaser_image_960_720"] ||
                          post["acf"]["teaser_image_719_135"]
                            ? _c("img", {
                                staticClass: "item-image item-image-135 w-100",
                                attrs: {
                                  alt: post["acf"]["teaser_image_alt_text"],
                                  src: _vm.wpApi.stripHost(
                                    post["acf"]["teaser_image_719_135"]
                                      ? post["acf"]["teaser_image_719_135"]
                                      : post["acf"]["teaser_image_960_720"]
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          post["acf"]["teaser_image_960_720"] ||
                          post["acf"]["teaser_image_339_125"]
                            ? _c("img", {
                                staticClass: "item-image item-image-125 w-100",
                                attrs: {
                                  alt: post["acf"]["teaser_image_alt_text"],
                                  src: _vm.wpApi.stripHost(
                                    post["acf"]["teaser_image_339_125"]
                                      ? post["acf"]["teaser_image_339_125"]
                                      : post["acf"]["teaser_image_960_720"]
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-card" }, [
                    _c(
                      "div",
                      { staticClass: "item-card-inner" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: _vm.wpApi.stripBaseUrl(post["link"]) }
                          },
                          [
                            _c("h4", {
                              staticClass: "item-heading",
                              domProps: {
                                innerHTML: _vm._s(post["acf"]["teaser_title"])
                              }
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "item-text",
                              domProps: {
                                innerHTML: _vm._s(post["acf"]["teaser_copy"])
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "btn",
                              {
                                staticClass:
                                  "btn btn-pink-white ani-btn-hover-scale-bounce"
                              },
                              [_vm._v("mehr erfahren")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.isLoaded && _vm.internalPosts.length === 0
        ? _c(
            "div",
            {
              staticClass: "col col-12 text-center text-center text-white my-4"
            },
            [_c("p", [_vm._v("Keine Einträge gefunden!")])]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a675e104", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a675e104","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/TeaserWide.vue
// module id = 624
// module chunks = 0